import VerifySpecificTrade from "./VerifySpecificTrade";
import VerifiedExchangeConnection from "./VerifiedExchangeConnection";
import VerifiedSharingAccount from "./VerifiedSharingAccount";
import "./VerifiedTrading.css";
import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useDispatch, useSelector } from "react-redux";
import TradeVerifiedLinkTable from "./TradeVerifiedLinkTable";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import StoringOnSolanaPlatform from "../../sharedPages/StoringOnSolanaPlatform";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { useAtom } from "jotai";
import { selectedOptionForOtpAtom, selectedRowsforVerifyMyTrade } from "../../../store/globalstore";
import { setRefetchSpecificUser } from "../../../redux/multicommunity/multicommunity";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify";
import PaymentSuccessModal from "../../sharedPages/PaymentSuccessModal";
import TradesVerifiedInfoModal from "../../sharedPages/TradesVerifiedInfoModal";
import StripePaymentModal from "../../sharedPages/StripePaymentModal";
import LoadingOverlayModal from "../../sharedPages/LoadingOverlayModal";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const VerifiedTrading = () => {
  const [searchParams] = useSearchParams(); //search params
  const sessionId = searchParams.get("session_id");
  const [clientSecret, setClientSecret] = useState("");
  const [refetchTable, setRefetchTable] = useState(false);
  const user = useSelector((value) => value?.user?.user);
  const [displayInfoModal, setDisplayInfoModal] = useState(false);
  const [verifiedTrade, setisverifiedTrade] = useState(false);
  const [displayLoadingOverlay, setDisplayLoadingOverlay] = useState(false);
  const [displaySolanaModal, setDisplaySolanaModal] = useState(false);
  const { currentTab } = useSelector((state) => state.links);
  const [selectedOptionForOtp, setSelectedOptionForOtp] = useAtom(selectedOptionForOtpAtom);
  const [selectedLiveTrades, setSelectedLiveTrades] = useState([]);
  const [blockChainLink, setBlockChainLink] = useState("");
  const [blockChainId, setBlockChainId] = useState("");
  const [paymentVerified, setPaymentVerified] = useState(false);
  const [blockchainApiCalled, setBlockchainApiCalled] = useState(false);
  const [selectedRowsForStatsCalculation, setSelectedRowsForStatsCalculation] =
    useAtom(selectedRowsforVerifyMyTrade);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const api = useApi();
  useEffect(() => {
    let element = null;
    if (currentTab === "AutoShare")
      element = document.getElementById("VerifiedSharingAccount");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  }, [currentTab]);

  useEffect(() => {
    if (clientSecret) {
      window.history.pushState({ showCheckout: true }, "");
    }
  }, [clientSecret]);

  useEffect(() => {
    const handlePopState = (event) => {
      if (clientSecret) {
        setClientSecret("");
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [clientSecret]);

  const sendUserDataOnBlockChain = async () => {
    try {
      setBlockchainApiCalled(true);
      const response=await api("post", "blocakChain/sendSelectedStatsOnBlockChain", {
        selectedTrades: selectedRowsForStatsCalculation,
        isLiveTrade: selectedOptionForOtp === "Live Trade" ? true : false,
      });
      
      if(!response.status||!response?.data?.blockchainInfo?.statsSentToBlockchain){
        throw response?.data?.blockchainInfo?.message||"Trade verification queued. You'll receive a notification when complete."
      }
      setBlockChainLink(response.data.blockchainInfo.blockChainUrl);
      setBlockChainId(response.data.blockchainInfo.blockchainId);
      setSelectedRowsForStatsCalculation([]);
      setLoading(false);
      dispatch(setRefetchSpecificUser(true));
      if (setRefetchTable) setRefetchTable(true);
      setisverifiedTrade(true);
      return setTimeout(() => {
        // const { pathname } = location;
        setisverifiedTrade(false);
        setDisplaySolanaModal(true);
        setTimeout(() => {
          setDisplaySolanaModal(false);
          setDisplayInfoModal(true);
          // showNotificationToast("Trade(s) verified!", `Here's the link ${response?.data?.blockchainInfo?.blockChainUrl}`);
          setDisplayLoadingOverlay(false);
        }, 3000);
        console.log("Successfully sent to blockchain API",response);
      }, 1500);
    } catch (error) {
      console.log(error,"of the error in send user data on blockchain");
      setisverifiedTrade(true);
      setTimeout(()=>{
      setSelectedRowsForStatsCalculation([]);
      setLoading(false);
      setDisplayLoadingOverlay(false);
      setisverifiedTrade(false);
      // dispatch(setRefetchSpecificUser(true));
      toastify("Trade verification queued. You'll receive a notification when complete.");
      navigate(location.pathname, { replace: true });
      console.log("Error sending to blockchain:", error);
      },1500)
      
    }
  };

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        setDisplayLoadingOverlay(true);
        setLoading(true);
        const response = await api(
          "get",
          `users/verifyTradeCheckoutOneTime?session_id=${sessionId}`
        );
      
        if (response?.status && response.data.paid) {
          setPaymentVerified(true);
          navigate(location.pathname, { replace: true });
          // toastify(
          //   "Verification complete. Find the link in the verified trading links."
          // );
        } else {
          setLoading(false);
          setDisplayLoadingOverlay(false);
          navigate(location.pathname, { replace: true });
          toastify(response.message||"Payment not completed or failed.");
        }
      } catch (error) {
        setLoading(false);
        setDisplayLoadingOverlay(false);
        navigate(location.pathname, { replace: true });
        console.error("Payment check failed:", error);
        toastify("Something went wrong");
      }
    };

    if (sessionId) checkPaymentStatus();
  }, [sessionId]);

  useEffect(() => {
    const handleBlockchainCall = async () => {
      if (
        paymentVerified &&
        !blockchainApiCalled &&
        selectedRowsForStatsCalculation.length > 0
      ) {
        await sendUserDataOnBlockChain();
      }
    };

    handleBlockchainCall();
  }, [paymentVerified, selectedRowsForStatsCalculation]);
  return (
    <>
      {(!displayLoadingOverlay&&!sessionId) && (
        <div className={`VerifiedTradingPage`}>
          
          {clientSecret ? (
            <StripePaymentModal
              setClientSecret={setClientSecret}
              clientSecret={clientSecret}
            />
          ) : (
            
            <>
              {user?.verifiedmyTrade?.connect && (
                <VerifySpecificTrade
                  selectedOptionForOtp={selectedOptionForOtp}
                  setSelectedOptionForOtp={setSelectedOptionForOtp}
                  selectedLiveTrades={selectedLiveTrades}
                  setSelectedLiveTrades={setSelectedLiveTrades}
                  setClientSecret={setClientSecret}
                  setSelectedRowsForStatsCalculation={
                    setSelectedRowsForStatsCalculation
                  }
                />
              )}
              {!user?.leaderCommunity && (
                <VerifiedExchangeConnection user={user} />
              )}
              {/* {user?.leaderCommunity && (
                <VerifiedLinkTable
                  refetchTable={refetchTable}
                  setRefetchTable={setRefetchTable}
                />
              )} */}
              {/* {!user?.leaderCommunity && ( */}
                <TradeVerifiedLinkTable
                  refetchTable={refetchTable}
                  setRefetchTable={setRefetchTable}
                />
              {/* )} */}
              {!user?.leaderCommunity && <VerifiedSharingAccount user={user} />}
            </>
          )}
        </div>
      )}
      {displaySolanaModal && <StoringOnSolanaPlatform />}
      {(displayLoadingOverlay||sessionId) && <LoadingOverlayModal />}
      {verifiedTrade && <PaymentSuccessModal />}
      {displayInfoModal && (
        <TradesVerifiedInfoModal blockChainId={blockChainId} blockChainLink={blockChainLink} setDisplayInfoModal={setDisplayInfoModal} />
      )}
    </>
  );
};

export default VerifiedTrading;
